/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { checkboxStyle } from './Checkbox.styles';

export interface CheckboxProps {
  /** 체크박스 오른쪽 문구. */
  label?: ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

/** 체크박스. 사이드바 "Show advanced dashboards", 필터 "Only include in KPI checks"에 활용. */
export function Checkbox({ label, checked, onChange }: CheckboxProps) {
  return (
    <label css={checkboxStyle}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      {label}
    </label>
  );
}
